import styled from 'styled-components'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@material-ui/core'
import { Icon } from '../icon/icon'
import { irem } from '../../utils'

export const StyledProductCardDetailContainer = styled(Grid)`
    &&& {
        width: 100%;
        margin-top: ${props => props.theme.typography.pxToRem(8)};
        margin-bottom: auto;

        .MuiAccordion-root {
            width: 100%;
        }
        
        + .MuiGrid-item {
            ${props => props.theme.breakpoints.up('md')} {
                margin-top: ${props => props.theme.typography.pxToRem(45)};
            }
        }
    }
`

export const StyledAccordion = styled(Accordion)`
  box-shadow: none;
    
    .MuiTableCell-root {
        border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    }
`

export const StyledAccordionTitleSpan = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-left: 0;
  }
`

export const StyledAccordionTitle = styled.p`
  color: inherit;
  font-weight: 500;
  font-size: ${props => props.theme.typography.pxToRem(15)};
  line-height: ${irem(27)};
  margin: 0 0 0 ${irem(5)};
`

export const StyledAccordionTitleIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(18)};
  transition: all 0.2s ease-out;
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  transition: border-color 0.1s ease-in;
  padding: ${irem(11)} 0;
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    
  ${StyledAccordionTitle}, ${StyledAccordionTitleIcon} {
    transition: color 0.1s ease-in-out;
  }
    
  && {
    min-height: 0;
  }
    
  .MuiAccordionSummary-content {
    margin: 0;
    padding: 0;
  }

  &:hover {
      color: ${props => props.theme.custom.colors.darkRed};
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`